import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { isRtl, LocaleContext } from '../../../i18n/src';
import { ICON_MAP } from './icon.map';
import { ICON_ANIMATION_MAP, ICON_COLOR_MAP, ICON_SIZES_MAP } from './icon.types';
/**
 * Icons provide a visual language that quickly communicates actions. They can be informational or interactive.
 */
export const Icon = ({ animation = 'none', color = 'gray', custom, name, onClick, size = 'base' }) => {
    const locale = useContext(LocaleContext);
    const registered = name ? ICON_MAP[name] : undefined;
    const IconComponent = custom !== null && custom !== void 0 ? custom : registered === null || registered === void 0 ? void 0 : registered.IconComponent;
    if (!IconComponent) {
        return null;
    }
    /**
     * Rotate or flip the icon based on the current locale and the icon's map metadata.
     * `verticalReverse` is a one-way flip (no LTR counterpart) — no current need for that.
     */
    const getOrientationStyles = () => {
        if (!registered) {
            return '';
        }
        const rtl = registered.supportsRTL && isRtl(locale);
        if (registered.verticalReverse ||
            (registered.horizontalReverse && !rtl) ||
            (!registered.horizontalReverse && rtl)) {
            return 'nucleus-transform nucleus-rotate-180';
        }
        return '';
    };
    const className = [
        'nucleus-inline-block nucleus-box-border nucleus-align-middle',
        ICON_COLOR_MAP[color],
        getOrientationStyles(),
        typeof size === 'string' ? ICON_SIZES_MAP[size] : '',
        onClick ? 'nucleus-cursor-pointer' : '',
        ICON_ANIMATION_MAP[animation],
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(IconComponent, { className: className, name: name, onClick: onClick, role: 'img', size: typeof size === 'number' ? size : undefined }));
};
//# sourceMappingURL=icon.component.js.map